import {Component, OnInit, Optional} from '@angular/core';
import {TableEntityExtension} from '../../extensions/table-entity-extension/table-entity.extension';
import {ITableHeader} from '../../../interfaces/table-header';
import {LoaderService} from '../../services/loader.service';
import {TableHeaderService} from '../../services/table-header.service';
import {ActivatedRoute} from '@angular/router';
import {CardService} from '../../components/card/card.service';
import {ReceiptService} from '../../services/receipt.service';
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ModalReceiptDetailsComponent} from '../../components/modals/modal-receipt-details/modal-receipt-details.component';
import {BsModalService} from 'ngx-bootstrap/modal';

@Component({
  selector: 'table-receipt',
  templateUrl: './table-receipt.component.html',
  providers: [LoaderService]
})
export class TableReceiptComponent extends TableEntityExtension implements OnInit {
  headers: ITableHeader[] = [
    this.tableHeaderService.id(),
    this.tableHeaderService.createdAt(),
    this.tableHeaderService.product({filter: {
        storeQuery: (this.query.filters.store || this.query.filters.parentStore) ? {
          parentStore: this.query.filters.store || this.query.filters.parentStore
        } : null
      }}),
    this.tableHeaderService.market(),
    this.tableHeaderService.receipt()
  ];

  query: any = {
    filters: {},
   order: null,
    relations: ['purchase', 'purchase.product', 'market']
  };

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: ReceiptService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private modalService: BsModalService,
              private tableHeaderService: TableHeaderService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
  }

  showReceipt(item: any) {
    this.modalService.show(ModalReceiptDetailsComponent, {
      initialState: { item },
    })
  }
}
